<template>
  <a-spin :spinning="loading">
    <div :style="{height:listHeight+'px'}" class="photo-list" ref="photoList">
      <a-affix :offset-top="0" :target="()=>this.$refs.photoList">
        <div style="padding:10px 15px 8px 15px;background:rgb(240, 242, 245);">
          <a-space :size="5">
            <a-pagination
                :hideOnSinglePage="false" :pageSize="params.page_size" :total="result.total" size="small"
                :page-size-options="pageSizeOpts" :show-size-changer="true" @showSizeChange="onShowSizeChange"
                :showTotal="total => `共 ${total} 张`" @change="refresh" class="pagination" v-model="params.page_no">
              <template slot="buildOptionText" slot-scope="props">
                <span>{{ props.value }}条/页</span>
              </template>
            </a-pagination>
            <BaseSelect v-model="params.order_by" :options="ConstValue.orderOpts"
                        placeholder="选择排序方式" @change="search" @ready="search"
                        state-key="order.by" size="small" style="width:126px;"/>
            <div v-if="selected.length"
                 style="border:1px #f50 solid;padding:0 10px;border-radius:10px;margin:1px 0 0 10px;">
              已选中{{ selected.length }}个
              <a-icon type="close-circle" @click="()=>clean(true)"/>
            </div>
          </a-space>
          <a-space :size="10" style="float:right;">
            <BoolSwitch v-if="withReward" :false-value="0" :true-value="1"
                        @change="search" title="有打赏 / 无原图" state-key="reward.origin" v-model="params.miss"/>
            <BoolSwitch :false-value="false" :true-value="true" state-key="detail.mode" title="详情"
                        v-model="detailMode"/>
          </a-space>
        </div>
      </a-affix>
      <div style="margin: 0 10px;" v-if="result.total">
        <div :class="{active: selected.indexOf(photo.id) !== -1, 'no-copy': noCopy}"
             :style="{width: colWidth+'px'}" @click="(e) => select(e, index)"
             class="photo-card" v-for="(photo, index) in result.data" :key="photo.id">
          <div :style="{height: colWidth+'px', lineHeight: colWidth-6+'px'}" class="img">
            <img v-lazy="result.thumb[photo.id]" alt=""/>
          </div>
          <div class="info" v-if="detailMode">
            <div><b>{{ photo.info.file_name | substr(0, 24) }}</b></div>
            <div>
              <span v-if="photo['raw']['id']">
                RAW <a-divider type="vertical"/>
              </span>
              <span v-if="photo.origin">
                原图 <a-divider type="vertical"/>
              </span>
              {{ photo["raw"]["size"] + photo["foto"]["size"] | bytes }}
              <a-divider type="vertical"/>
              {{ names[photo.member_id] | substr(0, 12) }}
              <span style="float: right; color: #1890ff;">
                <a-icon type="cloud-upload" @click="override(photo, result.thumb[photo.id])"/>
              </span>
            </div>
            <div>拍摄时间：{{ photo.info["catch_time"] | tsFormat("YYYY-MM-DD HH:mm:ss") }}</div>
            <div>上传时间：{{ photo["created_at"] | tsFormat("YYYY-MM-DD HH:mm:ss") }}</div>
            <div class="tags" v-if="withTags">
              <span :class="{active: photo.star}">标星</span>
              <span :class="{active: photo.release}">发布</span>
              <span :class="{active: photo.folder_id.length}">关联</span>
              <span :class="{active: photo.top}">置顶</span>
              <span :class="{active: photo.retouch > 1}">{{ retouchLabel(photo) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        <a-empty description="暂无图片，快去上传发布吧！"/>
      </div>
    </div>
    <Override ref="override" @override="refresh"/>
  </a-spin>
</template>

<script>
import func from "../../../../../utils/func";
import cache from "../../../../../utils/cache";
import enums from "../../../../../utils/enums";
import Override from "./Override";
import DelayLoading from "../../../../../comps/DelayLoading";
import BoolSwitch from "../../../../../comps/BoolSwitch";
import BaseSelect from "../../../../../comps/BaseSelect";

export default {
  name: "PhotoList",
  components: {BaseSelect, Override, BoolSwitch},
  mixins: [DelayLoading],
  props: {
    album: Object,
    queryParams: Object,
    decrWidth: Number,
    decrHeight: {
      type: Number,
      default: 105,
    },
    loadFunc: Function,
    withTags: Boolean,
    withReward: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      result: {
        total: 0,
        data: [],
        thumb: {}
      },
      params: {
        miss: 0,
        page_no: 1,
        page_size: 60,
      },
      names: {},
      lastIndex: 0,
      noCopy: false,
      detailMode: false,
      selected: this.$attrs.value,
      pageSizeOpts: ['60', '120', '240', '480'],
      ConstValue: require("../ConstValue").default,
    }
  },
  computed: {
    colWidth() {
      let range = this.detailMode ? [210, 250] : [110, 130];
      return func.computedColWidth({
        count: 8, gutter: 6, range: range,
        width: this.$store.getters["layout/contentWidth"] - this.decrWidth
      });
    },
    listHeight() {
      return this.$store.getters["layout/contentHeight"] - this.decrHeight;
    },
    retouchParams() {
      let params = func.copyObject(this.queryParams);
      return Object.assign(params, {miss: this.params.miss});
    }
  },
  mounted() {
    cache.v1.album.member.names(this.album.id, enums.Role.Grapher).then(res => this.names = res);
  },
  created() {
    document.documentElement.addEventListener("keydown", this.ctrlA);
    document.documentElement.addEventListener("keyup", this.setCopyable);
    document.documentElement.addEventListener("keydown", this.setCopyable);
  },
  destroyed() {
    document.documentElement.removeEventListener("keydown", this.ctrlA);
    document.documentElement.removeEventListener("keyup", this.setCopyable);
    document.documentElement.removeEventListener("keydown", this.setCopyable);
  },
  methods: {
    ctrlA(e) {
      if (e.ctrlKey || e.shiftKey || e.altKey) e.preventDefault();
      if ((e.ctrlKey || e.altKey) && e.code === "KeyA") this.selectAll();
    },
    select(e, index) {
      if (!e.ctrlKey && !e.altKey && !e.shiftKey) this.clean(false);
      if (e.shiftKey) this.shiftSelect(index);
      else this.append(index, true);
      this.lastIndex = index; // log last
      this.$emit("input", this.selected);
    },
    clean(emit) {
      this.selected = [];
      this.lastIndex = 0;
      emit && this.$emit("input", []);
    },
    append(index, remove) {
      let item = this.result.data[index];
      let position = this.selected.indexOf(item.id);
      if (position === -1) this.selected.push(item.id);
      else if (remove) this.selected.splice(position, 1);
    },
    override(photo, thumb) {
      this.$refs.override.open(photo, thumb);
    },
    selectAll() {
      this.clean(false);
      this.result.data.forEach((item, index) => {
        this.append(index, false);
      });
      this.$emit("input", this.selected);
    },
    shiftSelect(index) {
      let min = Math.min(index, this.lastIndex);
      let max = Math.max(index, this.lastIndex);
      for (let i = min; i <= max; i++) this.append(i, false);
    },
    setCopyable(e) {
      this.noCopy = e.ctrlKey || e.shiftKey;
    },
    retouchLabel(photo) {
      return enums.Retouch.labels[photo.retouch];
    },
    onShowSizeChange(current, pageSize) {
      this.params.page_size = pageSize;
      this.search();
    },
    search() {
      this.params.page_no = 1;
      this.clean(true);
      this.refresh();
    },
    refresh() {
      const self = this;
      this.queryParams.with_thumb = 1; // with thumb default
      let args = Object.assign({}, self.queryParams, self.params);
      return this.withLoading(0, () => self.loadFunc(self.album.id, args)).then(res => self.result = res);
    },
  }
}
</script>

<style lang="less" scoped>
.photo-list {
  overflow-y: scroll;
  padding-bottom: 7px;

  .empty {
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .photo-card {
    float: left;
    margin: 3px;
    cursor: pointer;
    display: block;
    background: #fff;
    border: 2px #f0f2f5 solid;

    .img {
      width: 100%;
      display: block;
      text-align: center;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .info {
      font-size: 12px;
      padding: 5px 10px;

      .ant-divider {
        margin: 0 5px;
      }

      .tags {
        display: block;
        padding: 2px 0;
        margin-right: -5px;

        span {
          color: #aaa;
          padding: 0 5px;
          border-radius: 2px;
          background: #eee;
          font-size: 12px;
          display: inline-block;
          transform-origin: 0;
          transform: scale(0.90);
          -webkit-transform-origin: 0;
          -webkit-transform: scale(0.90);
        }

        .active {
          color: #fff;
          background: #ff5500;
        }
      }
    }
  }

  .active {
    border-color: #ff5500;
  }

  .no-copy {
    user-select: none;
    -ms-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }
}
</style>
